import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react'
import DataTable from 'src/components/tables/DataTable';
import { colDefs } from './constants';
import { useNavigate } from 'react-router-dom';
import { getQuestions } from 'src/view-models/Question';
import Loading from 'src/components/loading/Loading';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import DeleteModal from './components/DeleteModal';

const Questions = () => {
  const dispatch = useAppDispatch()
  const navigation = useNavigate()
  const { questions } = useAppSelector((state) => state.question)
  const [isLoading, setIsLoading] = useState(true)

  const goToAddQuestion = () => {
    navigation('/admin/questions/new')
  }

  useEffect(() => {
    const fetchQuestions = async () => {
      await getQuestions(dispatch)
      setIsLoading(false)
    }
    fetchQuestions()
  }, [])

  const goToPatientQuestionsView = () => {
    navigation('/admin/questions/patiente-view')
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box px={4} py={2} rounded={4}  >
      <DeleteModal />
      <Flex height={'100px'} flexDirection={{ base: 'column', md: 'row' }} alignItems={{ base: 'flex-start', md: 'center' }} justifyContent='space-between' gap={4} >
        <Box>
          <Text color='#4E5D78' fontWeight={700} fontSize={30} >Questions</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant Questionnaires </Text>
        </Box>
        <HStack>
          <Button colorScheme='blue' onClick={goToPatientQuestionsView}>Vue Formulaire Patiente</Button>
          <Button colorScheme='blue' onClick={goToAddQuestion}>Ajouter Un Questionnaire</Button>
        </HStack>
      </Flex>
      <Box py={8}>
        <DataTable columns={colDefs} data={questions} />
      </Box>
    </Box>
  )
}

export default Questions